import { gql } from '@apollo/client';

export const dependentsName = 'ClaimedDependents';
export const dependents = gql`
	fragment ${dependentsName} on Member {
		claimedDependents {
			id
			email
			attestation
		}
	}
`;
